/*eslint-disable*/
import { createStore, compose, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { rootReducer } from "../reducers/rootReducer";
import { env } from "../config/vars";

const composeEnhancers =
  (typeof window !== "undefined" &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

export const store = createStore(
  rootReducer,
  env == "development"
    ? composeEnhancers(applyMiddleware(thunk))
    : applyMiddleware(thunk)
);
